/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { MouseOrTouchEvent } from "../Types/THelperTypes";

export function getMouseOrTouchEventData(event: MouseOrTouchEvent): MouseEvent | Touch {
	return (event as TouchEvent).changedTouches
		? (event as TouchEvent).changedTouches[0]
		: (event as MouseEvent);
}
